import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { FiArrowRight, FiTag } from "react-icons/fi";
import AffiliateOfferModal from "./AffiliateOfferModal";
import { useAuth } from "context/auth-context";
import { getAffiliateOffers } from "./affiliateApi";
import { getCountryCode, getIpAddressByIPify } from "components/JoinNowForm/getdata";

const AffiliateOffers = () => {
  const { auth } = useAuth();
  const [selectedOffer, setSelectedOffer] = useState<any>(null);
  const [ipAddress, setIpAddress] = useState("");
  const [countryCode, setCountryCode] = useState("");

  useEffect(() => {
    const fetchIp = async () => {
      const ip = await getIpAddressByIPify();
      const countryCode = await getCountryCode(setCountryCode);
      setIpAddress(ip);
      setCountryCode(countryCode);
    };

    fetchIp();
  }, []);

  const { data, isLoading } = useQuery(
    ["affiliateOffers", auth.panelistId],
    () => getAffiliateOffers(auth.panelistId, countryCode),
    {
      refetchOnWindowFocus: false,
      enabled: !!auth.panelistId && !!countryCode,
    },
  );

  const offers = data?.offers || [];

  if (isLoading)
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4" aria-busy="true">
        <span className="sr-only">Loading offers...</span>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="overflow-hidden zs-card">
            <div className="h-[150px] zs-skeleton !rounded-none" />
            <div className="flex flex-col gap-2 p-4">
              <div className="w-2/3 h-4 zs-skeleton" />
              <div className="w-full h-3 zs-skeleton" />
            </div>
          </div>
        ))}
      </div>
    );

  return (
    <section>
      {offers.length > 0 && (
        <div className="flex items-center gap-3 mb-3">
          <span className="zs-stat-icon bg-accent-soft text-accent">
            <FiTag />
          </span>
          <div className="min-w-0">
            <h2 className="zs-section-title">Special Deals for you</h2>
            <p className="text-sm text-ink-3">Partner offers selected for your account.</p>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {offers.map((offer: any) => (
          <div
            key={offer.id}
            onClick={() => setSelectedOffer(offer)}
            className="flex flex-col overflow-hidden cursor-pointer zs-card zs-card-interactive group"
          >
            <div className="relative overflow-hidden bg-surface-2">
              <img
                src={offer.banner_url}
                alt=""
                className="w-full h-[150px] object-cover transition-transform duration-300 group-hover:scale-[1.03]"
              />
            </div>

            <div className="flex flex-col flex-1 gap-1 p-4">
              <h3 className="text-[15px] font-semibold leading-snug text-ink">{offer.title}</h3>
              <p className="text-sm leading-relaxed text-ink-3">{offer.description}</p>
              <span className="inline-flex items-center gap-1 pt-2 mt-auto text-sm font-medium text-primary-text">
                View Details
                <FiArrowRight className="transition-transform group-hover:translate-x-0.5" />
              </span>
            </div>
          </div>
        ))}
      </div>

      {selectedOffer && (
        <AffiliateOfferModal
          offer={selectedOffer}
          userId={auth.panelistId}
          onClose={() => setSelectedOffer(null)}
          ipAddress={ipAddress}
        />
      )}
    </section>
  );
};

export default AffiliateOffers;
